import { createRouter, createWebHistory } from 'vue-router';
import routes from "./routes";
import {useAuthStore} from "@/stores/useAuthStore";
import {useAppStore} from "@/stores/useAppStore";
import {authApi} from "@/api/authApi";
import {ApiError} from "@codeages-private/qingjs-vue-skeleton-base";
import { tr } from 'date-fns/locale';

const router = createRouter({
    history: createWebHistory(),
    routes
});

router.beforeEach(async (to) => {

    const auth = useAuthStore();
    if (auth.authToken && !auth.isSignin) {
        try {
            const user = await authApi.signinByToken(auth.authToken);
            auth.signin(user);
        } catch(err: unknown) {
            if (err instanceof ApiError) {
                if (err.status === 401) {
                    console.log("401");
                    auth.signout();
                    return {name: "Signin"};
                }
            }
            const app = useAppStore();
            app.setError(err);
        }
    }

    if ((to.meta.auth === undefined || to.meta.auth === true) && !auth.isSignin) {
        return {name: "Signin"}
    }

    if (to.meta.roles !== undefined) {

        const roles = to.meta.roles as string[];
        let isAuthorized = false;
        
        roles.forEach((role: string) => {
            if (auth.user.roles.includes(role)) {
                isAuthorized = true;
            }
        })
        if (!isAuthorized) {
            return {name: "Root"}
        }
    }

    if (to.meta.title) {
        const app = useAppStore();
        app.setTitle(to.meta.title as string);
    }

    return true;
});
export default router;
